import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { AnimatePresence, motion } from 'framer-motion';
import { SttModal } from '@stt-componentes/core-v3';

import frame1 from './imagens/frame1.svg';
import frame2 from './imagens/frame2.svg';
import frame3 from './imagens/frame3.svg';
import frameFinal from './imagens/frame4.svg';

const Container = styled(Grid)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    gap: '40px',
    padding: '1em',
});

const TextRow = styled(Typography)({
    textAlign: 'center',
});

const Animacao = styled(Grid)({
    position: 'relative',
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    backgroundColor: '#0A6FB8',
    overflow: 'hidden',
});

const Animation = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(0);
  }
`;

const Ponto = styled('span')`
    display: inline-block;
    animation: ${Animation} 1s infinite steps(1);
    color: inherit;

    &:nth-of-type(1) {
        animation-delay: 0s;
    }

    &:nth-of-type(2) {
        animation-delay: 0.2s;
    }

    &:nth-of-type(3) {
        animation-delay: 0.4s;
    }
`;

const frames = [frame1, frame2, frame3];

const ANIMATION_TIME_MS = 3000;

const SttCarregando = () => {
    const [showFrame, setShowFrame] = useState(true);

    // Loop dos Frames
    useEffect(() => {
        const interval = setInterval(() => {
            setShowFrame((prev) => !prev);
        }, ANIMATION_TIME_MS);

        return () => clearInterval(interval);
    }, []);

    return (
        <SttModal open={true} maxWidth="lg" outModalClose={() => {}} sx={{ '& .MuiPaper-root': { borderRadius: 2 } }}>
            <Container>
                <Animacao>
                    <AnimatePresence>
                        {showFrame && (
                            <>
                                {frames.map((frame, index) => (
                                    <motion.img
                                        layout
                                        style={{ width: '50px', left: '25px', top: '40px', position: 'absolute' }}
                                        key={index}
                                        src={frame}
                                        initial={{ y: -70, opacity: 0 }}
                                        animate={{ y: 10 * (-index + 1), opacity: 1 }}
                                        exit={{ y: 70, opacity: 1 }}
                                        transition={{
                                            duration: 2.0,
                                            type: 'spring',
                                            mass: 1,
                                            stiffness: 344.1,
                                            damping: 20,
                                            delay: 0.5 * index,
                                        }}
                                    />
                                ))}
                                <motion.img
                                    style={{
                                        width: '50px',
                                        left: '40px',
                                        top: '40px',
                                        position: 'absolute',
                                        transform: 'rotate(75.00deg)',
                                    }}
                                    src={frameFinal}
                                    initial={{ x: -70, opacity: 0 }}
                                    animate={{ x: 0, opacity: 1 }}
                                    exit={{ x: 50, opacity: 1 }}
                                    transition={{
                                        type: 'spring',
                                        duration: 1.0,
                                        mass: 1,
                                        stiffness: 344.1,
                                        damping: 20,
                                        delay: 1.5,
                                    }}
                                />
                            </>
                        )}
                    </AnimatePresence>
                </Animacao>
                <TextRow variant="h5" color="primary">
                    Carregando
                    <Ponto>.</Ponto>
                    <Ponto>.</Ponto>
                    <Ponto>.</Ponto>
                </TextRow>
            </Container>
        </SttModal>
    );
};

export default SttCarregando;
